module.exports = __webpack_public_path__ + "static/media/SlatePro.d04426bd.otf";